module.exports = __webpack_public_path__ + "static/media/logo-maroon-whiteBG.0642bcf4.svg";